import { isSimpleRecurrence, recurrenceIntervalString } from '@frontend/api-client';
import type { Recurrence, SimpleRecurrence } from '@frontend/api-types';
import { capitalize, dayjs } from '@frontend/duck-tape';
import { StartSoonTaskBadge } from '@frontend/web-icons';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import { applyClass, concatClasses } from '@frontend/web-utils';
import { NavLinkWrapper } from '@frontend/web/components/';

export type RecurrenceCardProps = {
  hasBorderBottom?: boolean;
  isDisabled?: boolean;
  recurrence: Recurrence | SimpleRecurrence;
};
export const RecurrenceCard = ({ hasBorderBottom, isDisabled, recurrence }: RecurrenceCardProps) => {
  const simple = isSimpleRecurrence(recurrence);
  const title = simple ? recurrence.taskName : recurrence.name;
  const nextDate = simple ? recurrence.nextTriggerAt : recurrence.nextTaskDueDate;

  return (
    <NavLinkWrapper
      className="flex gap-md px-md items-center w-full grow-1 shrink-1"
      disabled={isDisabled}
      params={{ recurrenceId: recurrence.id }}
      to={'/app/recurrence/$recurrenceId'}
    >
      <YStack
        alignItems="center"
        bg="neutral100"
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className="relative items-center justify-center size-[48px] rounded-[24px]"
        justifyContent="center"
      >
        <Icon color="neutral" name="IconRefresh" size={29} />
        <YStack className="bottom-none right-none absolute">
          <StartSoonTaskBadge />
        </YStack>
      </YStack>
      <YStack
        className={concatClasses(
          applyClass(hasBorderBottom, 'border-b-neutral-200 border-b-1 '),
          'py-md grow-1 shrink-1',
        )}
      >
        <Text type="h5">{title}</Text>
        <XStack alignItems="center" gapX="xs">
          {simple ? (
            <Text color="tertiary" lineClamp={1} type="p-sm">
              {capitalize(recurrence.state)}
            </Text>
          ) : (
            <Text color="tertiary" lineClamp={1} type="p-sm">
              {recurrenceIntervalString(recurrence)}
            </Text>
          )}
          {nextDate ? (
            <>
              <Text color="tertiary" type="p-sm">
                •
              </Text>
              <Text color="tertiary" lineClamp={1} type="p-sm">
                Next: {dayjs(nextDate).format('M/D')}
              </Text>
            </>
          ) : null}
        </XStack>
      </YStack>
    </NavLinkWrapper>
  );
};
